var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-nowrap"},_vm._l((_vm.currentActions),function(item,index){return _c('div',{key:index,staticClass:"d-inline-block mx-2"},[(item === 'view' && _vm.certificate)?_c('a',{staticClass:"icon icon-eye",attrs:{"href":_vm.certificate,"target":"_blank","aria-label":""}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }